import { httpClient } from '@/services/http/httpClient'

export async function recalculateUserScores(tennantId?: string) {
  await httpClient.post('/tennants/configs/points/recalculate', {
    tennantId,
  })
}
